/** Small viewports: below Tailwind's `sm` (40rem). The drawer becomes a
 * bottom sheet and diffs switch to their small-screen layout. */
export const SMALL_VIEWPORT_QUERY = "(max-width: 39.999rem)"

/** Wide enough for a file tree beside the code (Tailwind's `lg`). Narrower,
 * the diff drawer names the current file in a chip that opens the file list. */
export const SIDE_BY_SIDE_TREE_QUERY = "(min-width: 64rem)"

/** A coarse primary pointer (touch): no autofocus that would raise the
 * on-screen keyboard, and 44px tap targets. */
export const COARSE_POINTER_QUERY = "(pointer: coarse)"

/** No hover: nothing moves away to dismiss a hover-only affordance, such as a
 * tooltip or the line comment button. */
export const NO_HOVER_QUERY = "(hover: none)"
